import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store";

class CashFlowDataService {
    GetProcessedCashFlowData(start, end): Promise<any> {

        let startText = `${start.getFullYear()}-${(start.getMonth() + 1) < 10 ? ('0' + (start.getMonth() + 1)) : (start.getMonth() + 1)}-${start.getDate() < 10 ? ('0' + start.getDate()) : start.getDate()}`;
        let endText = `${end.getFullYear()}-${(end.getMonth() + 1) < 10 ? ('0' + (end.getMonth() + 1)) : (end.getMonth() + 1)}-${end.getDate() < 10 ? ('0' + end.getDate()) : end.getDate()}`


        return http.clientRapoarte.get(`CashFlow/GetProcessedCashFlowData?from=${startText}&to=${endText}`);//de test, momentan
    }

    GetDSH_BanciSolduri() {
        return http.clientRapoarte.get(`CashFlow/GetDSH_BanciSolduri`);
    }


}

export default new CashFlowDataService();